import { render } from "./Home.vue?vue&type=template&id=58920394&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=58920394&scoped=true&lang=css"

import exportComponent from "/Users/times/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58920394"]])

export default __exports__